/* CARAVIUM ficha visual fixes: desktop + mobile */
(() => {
  'use strict';

  const ROOT_ID = 'caravium-area-ficha';
  const DESKTOP_BANNER_URL = 'https://cdn.shopify.com/s/files/1/1032/3086/5785/files/bannercaravium.png?v=1787655666';
  const normalize = (v) => String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const isMobile = () => window.matchMedia('(max-width: 820px)').matches;

  const hideExactText = (root, wanted) => {
    const target = normalize(wanted);
    root.querySelectorAll('h1,h2,h3,h4,h5,h6,div,span,p,strong,small').forEach((el) => {
      if (normalize(el.textContent) === target) el.style.setProperty('display', 'none', 'important');
    });
  };

  const removeUtilityLabels = (root) => {
    hideExactText(root, 'Información útil');
    hideExactText(root, 'Guía del destino');
  };

  const removeDuplicateContactAddress = (root) => {
    const section = root.querySelector('.cv-contact-section, #cv-contacto');
    if (!section) return;
    section.querySelectorAll('.cv-contact-card').forEach((card) => {
      const strong = card.querySelector('strong');
      if (normalize(strong?.textContent) === 'direccion') card.remove();
    });
  };

  const styleParagraph = (p, isLast = false) => {
    p.style.setProperty('margin', isLast ? '0' : '0 0 18px', 'important');
    p.style.setProperty('line-height', '1.7', 'important');
  };

  const splitIntoReadableChunks = (text) => {
    const clean = String(text || '').replace(/\s+/g, ' ').trim();
    if (!clean) return [];
    const sentences = clean.split(/(?<=[.!?])\s+(?=[A-ZÁÉÍÓÚÜÑ0-9])/).filter(Boolean);
    if (sentences.length < 2) return [clean];
    const chunks = [];
    let current = '';
    sentences.forEach((sentence) => {
      const candidate = current ? `${current} ${sentence}` : sentence;
      if (current && candidate.length > 250) {
        chunks.push(current);
        current = sentence;
      } else {
        current = candidate;
      }
    });
    if (current) chunks.push(current);
    return chunks;
  };

  const fixDestinationParagraphs = (root) => {
    if (!isMobile()) return;
    root.querySelectorAll('.cv-destination-section .cv-tourism-body-copy, .cv-destination-section .cv-tourism-body').forEach((container) => {
      if (container.dataset.cvParagraphFix === '1') return;
      const paragraphs = Array.from(container.querySelectorAll(':scope > .cv-destination-paragraph'));
      if (paragraphs.length === 1) {
        const original = paragraphs[0];
        const chunks = splitIntoReadableChunks(original.textContent);
        if (chunks.length > 1) {
          const fragment = document.createDocumentFragment();
          chunks.forEach((chunk, index) => {
            const p = document.createElement('p');
            p.className = original.className || 'cv-destination-paragraph';
            p.textContent = chunk;
            styleParagraph(p, index === chunks.length - 1);
            fragment.appendChild(p);
          });
          original.replaceWith(fragment);
        } else {
          styleParagraph(original, true);
        }
      } else {
        paragraphs.forEach((p, index) => styleParagraph(p, index === paragraphs.length - 1));
      }
      container.dataset.cvParagraphFix = '1';
    });
  };

  const fixBanner = (root) => {
    if (!isMobile()) return;
    const banner = root.querySelector('.cv-travel-banner');
    if (!banner) return;
    const desktopImg = banner.querySelector('.cv-travel-banner-desktop');
    const mobileImg = banner.querySelector('.cv-travel-banner-mobile');
    banner.style.setProperty('width', '100%', 'important');
    banner.style.setProperty('margin', '24px auto 28px', 'important');
    banner.style.setProperty('overflow', 'hidden', 'important');
    if (mobileImg) {
      mobileImg.src = DESKTOP_BANNER_URL;
      mobileImg.style.setProperty('display', 'block', 'important');
      mobileImg.style.setProperty('width', '100%', 'important');
      mobileImg.style.setProperty('height', 'auto', 'important');
      mobileImg.style.setProperty('max-height', 'none', 'important');
      mobileImg.style.setProperty('object-fit', 'contain', 'important');
    }
    if (desktopImg) {
      desktopImg.style.setProperty('display', mobileImg ? 'none' : 'block', 'important');
      desktopImg.style.setProperty('width', '100%', 'important');
      desktopImg.style.setProperty('height', 'auto', 'important');
    }
  };

  const fixRepeatedCategory = (root) => {
    const hero = root.querySelector('.cv-hero, .cv-hero-card') || root;
    const title = hero.querySelector('h1');
    if (!title) return;
    const titleNorm = normalize(title.textContent);
    hero.querySelectorAll('.cv-eyebrow, .cv-category, .cv-hero-category, .cv-kicker').forEach((el) => {
      const cat = normalize(el.textContent);
      if (cat && (titleNorm === cat || titleNorm.startsWith(`${cat} `))) el.style.setProperty('display', 'none', 'important');
    });
    const node = title.previousElementSibling;
    if (node) {
      const cat = normalize(node.textContent);
      if (cat && cat.length < 40 && titleNorm.startsWith(`${cat} `)) node.style.setProperty('display', 'none', 'important');
    }
  };

  const vehicleSvg = (label) => {
    const n = normalize(label);
    if (n.includes('caravana') && !n.includes('autocaravana')) return '<svg viewBox="0 0 64 40" aria-hidden="true"><path d="M8 8h36c6 0 10 4 10 10v10H8V8Z"/><path d="M54 24h6v4h-6zM3 27h57v3H3z"/><circle cx="20" cy="32" r="5"/><circle cx="46" cy="32" r="5"/><path d="M10 12h13v9H10zM27 12h13v9H27z" class="cut"/></svg>';
    if (n.includes('camper')) return '<svg viewBox="0 0 64 40" aria-hidden="true"><path d="M5 12h39l10 9 5 2v7H5V12Z"/><path d="M44 15h6l6 7H44zM10 16h15v8H10z" class="cut"/><circle cx="18" cy="32" r="5"/><circle cx="49" cy="32" r="5"/></svg>';
    return '<svg viewBox="0 0 64 40" aria-hidden="true"><path d="M5 7h38c6 0 10 4 12 10l4 10v3H5V7Z"/><path d="M39 11h8c3 2 5 5 6 9H39zM10 12h14v10H10z" class="cut"/><circle cx="18" cy="32" r="5"/><circle cx="49" cy="32" r="5"/></svg>';
  };

  const fixVehicleIcons = (root) => {
    root.querySelectorAll('.cv-vehicle').forEach((item) => {
      const icon = item.querySelector('.cv-vehicle-icon');
      if (!icon || icon.dataset.cvSvg === '1') return;
      const label = Array.from(item.children).find((el) => el !== icon)?.textContent || item.textContent;
      icon.innerHTML = vehicleSvg(label);
      icon.dataset.cvSvg = '1';
      icon.style.setProperty('font-size', '0', 'important');
      icon.style.setProperty('width', '42px', 'important');
      icon.style.setProperty('height', '32px', 'important');
      icon.style.setProperty('display', 'flex', 'important');
      icon.style.setProperty('align-items', 'center', 'important');
      icon.style.setProperty('justify-content', 'center', 'important');
      const svg = icon.querySelector('svg');
      if (svg) {
        svg.style.width = '40px';
        svg.style.height = '28px';
        svg.style.fill = '#123b5d';
        svg.querySelectorAll('.cut').forEach((el) => { el.style.fill = '#ffffff'; });
      }
    });
  };

  const fixReviewPhoneSpacing = (root) => {
    const sections = Array.from(root.querySelectorAll('.cv-section'));
    const reviewSection = sections.find((s) => /opiniones|reseña/i.test(s.textContent || ''));
    if (reviewSection) reviewSection.style.setProperty('margin-bottom', '38px', 'important');
    const reviewButton = Array.from(root.querySelectorAll('a,button')).find((el) => /escribir una reseña/i.test(el.textContent || ''));
    if (reviewButton) {
      const host = reviewButton.closest('.cv-section') || reviewButton.parentElement;
      if (host) host.style.setProperty('margin-bottom', '38px', 'important');
    }
  };

  const fixMapEmbed = (root) => {
    const frame = root.querySelector('.cv-map iframe');
    if (!frame || frame.dataset.cvMapClean === '1') return;

    let current;
    try { current = new URL(frame.src, location.href); } catch { return; }
    const q = current.searchParams.get('q') || '';
    const match = q.match(/^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*$/);
    if (!match) return;

    const lat = match[1];
    const lng = match[2];
    frame.dataset.cvMapClean = '1';
    frame.src = `https://www.google.com/maps?ll=${encodeURIComponent(lat)},${encodeURIComponent(lng)}&z=15&output=embed`;
    frame.setAttribute('title', 'Ubicación del lugar en el mapa');

    const map = frame.closest('.cv-map');
    if (!map) return;
    map.style.setProperty('position', 'relative', 'important');

    if (!map.querySelector('.cv-map-center-pin')) {
      const pin = document.createElement('div');
      pin.className = 'cv-map-center-pin';
      pin.setAttribute('aria-hidden', 'true');
      pin.innerHTML = '<span></span>';
      pin.style.cssText = 'position:absolute;left:50%;top:50%;width:30px;height:30px;transform:translate(-50%,-100%) rotate(-45deg);border-radius:50% 50% 50% 10%;background:#d93025;border:3px solid #fff;box-shadow:0 3px 10px rgba(0,0,0,.30);z-index:5;pointer-events:none;';
      const dot = pin.querySelector('span');
      if (dot) dot.style.cssText = 'display:block;width:9px;height:9px;border-radius:50%;background:#fff;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);';
      map.appendChild(pin);
    }
  };

  const apply = () => {
    const root = document.getElementById(ROOT_ID);
    if (!root) return false;
    removeUtilityLabels(root);
    removeDuplicateContactAddress(root);
    fixRepeatedCategory(root);
    fixVehicleIcons(root);
    fixReviewPhoneSpacing(root);
    fixBanner(root);
    fixDestinationParagraphs(root);
    fixMapEmbed(root);
    return true;
  };

  const boot = () => {
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      apply();
      if (attempts >= 80) clearInterval(timer);
    }, 250);

    apply();
    window.addEventListener('resize', apply, { passive: true });

    const root = document.getElementById(ROOT_ID);
    if (root) {
      let queued = false;
      const observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          apply();
        });
      });
      observer.observe(root, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 30000);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
